import { render, staticRenderFns } from "./VItemSelect.vue?vue&type=template&id=3f94a5fe"
import script from "./VItemSelect.vue?vue&type=script&lang=ts"
export * from "./VItemSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports